module.exports = __webpack_public_path__ + "img/Al-Harith2.27556957.jpg";